import type { HomeBlock } from './types';

/**
 * Карточка блока на Главной (Экран 2.0).
 *
 * v0.4 (ADR-0023): text-only, без lucide иконок. 2px solid accent border + white
 * card bg + ink text для всех карточек unconditionally.
 *
 * v0.4.1 (H2.3): featured filled style удалён — Видеоинструкция (id=1) теперь
 * рендерится через dedicated `<VideoButton>` component, и единственный
 * conditional bg на BlockCard отпал. Все карточки выглядят одинаково.
 *
 * Источник истины — `docs/prototypes/_design_spike/screen-home-spike.html`
 * (`Card` component, lines 367-398) + Aibek H2.3 preview tweaks.
 */
export interface BlockCardProps {
  block: HomeBlock;
  onClick: (block: HomeBlock) => void;
}

export function BlockCard({ block, onClick }: BlockCardProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(block)}
      aria-label={`Открыть ${block.title}`}
      className={
        'w-full text-left rounded-xl px-4 py-3 transition-transform ' +
        'hover:scale-[0.995] active:scale-[0.985] ' +
        'border-2 border-accent shadow-card bg-card ' +
        'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none ' +
        (block.available ? '' : 'opacity-60')
      }
    >
      <div className="text-[15px] font-medium leading-snug text-ink">{block.title}</div>
      {block.desc ? (
        <div className="text-[12px] mt-0.5 leading-snug text-muted">{block.desc}</div>
      ) : null}
    </button>
  );
}
